import React, { useState } from 'react';
import AccordionPanel from './AccordionPanel';

const Accordion = props => {
    const [showPanel, setShowPanel] = useState(false);

    const togglePanelHandler = () => {
        if (showPanel) {
            setShowPanel(false);
        } else {
            setShowPanel(true);
        }
    };

    return (
        <div className="container variantPickerComponent-accordionContainer">
            <div className="row">
                <div className="col-xs-12">
                    <button className={showPanel ? "variantPickerComponent-btnAccordion is-active" : "variantPickerComponent-btnAccordion"} onClick={togglePanelHandler}>
                        {props.buttonText}
                        <svg className="variantPickerComponent-btnAccordionSvg" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                            <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" />
                            <path d="M0 0h24v24H0V0z" fill="none" />
                        </svg>
                    </button>

                    {showPanel && <AccordionPanel addToCart={props.addToCart} data={props.data} title={props.title} description={props.description} />}
                </div>
            </div>
        </div>
    );
};

export default Accordion;